import {ThemeProvider} from 'styled-components';
import { Routes, Route } from "react-router-dom";
import React, { useEffect } from 'react';
import { CookiesProvider } from 'react-cookie'

import './App.css';
import {theme} from './styles/styles';
import InputPage from './pages/InputPage/InputPage';
import LandingPage from './pages/LandingPage/LandingPage';
import Loading from './components/Loading/Loading';
import Analysis from './pages/AnalysisPage/AnalysisPage';
import Costs from './components/Costs/Costs';
import ROI from './components/ROI/ROI';
import Incentives from './components/Incentives/Incentives';
import FAQs from './components/FAQs/FAQs';
import Header from './components/Header/Header';

import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { assignToken } from './features/token/token';
import Footer from './components/Footer/Footer';

function App() {
  const token = useSelector((state) => state.token.value);
  const dispatch = useDispatch();

  useEffect(() => {
     if (!token) {
        const username= process.env.REACT_APP_APP_USERNAME;
        const password= process.env.REACT_APP_APP_PASSWORD;
        const authToken = btoa(`Basic ${username}:${password}`);
        axios.get(`${process.env.REACT_APP_API_URL}api/login`,
           { headers: 
              { 
              'Authorization': `${authToken}`, 
              'Content-Type': 'application/json'
              }
           }
        )
        .then(response => {
           dispatch(assignToken(response.data['token']));
           console.log("Fetched token successfully");
        })
        .catch(error => {
           console.error(error);
        });
     }
  });
 
  
  return (
    <CookiesProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/input" element={<InputPage />} />
            <Route path="/loading" element={<Loading />} />
            <Route path="/analysis" element={<Analysis />}>
              <Route path="roi" element={<ROI />} />
              <Route path="incentives" element={<Incentives />} />
              <Route path="costs" element={<Costs />} />
              <Route path="faqs" element={<FAQs />} />
            </Route>
          </Routes>
        </div>
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;
